module.exports = __webpack_public_path__ + "static/media/approved.692253d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/approved.svg
// module id = 947
// module chunks = 0